// extracted by mini-css-extract-plugin
export default {"uskLabelSmall":"uskLabelSmall__eoQWt","uskImage":"uskImage__kTvyM","uskImageLarge":"uskImageLarge__p_wcm","uskSection":"uskSection__UjChq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"uskLabelSmall\":\"uskLabelSmall__eoQWt\",\"uskImage\":\"uskImage__kTvyM\",\"uskImageLarge\":\"uskImageLarge__p_wcm\",\"uskSection\":\"uskSection__UjChq\"}";
        // 1787130556870
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  